// extracted by mini-css-extract-plugin
export default {"tooltip":"zp-z","sharingV2":"Ap-z","sharingIconsV2":"Bp-z","links":"Cp-z","link":"Dp-z","facebookV2":"Ep-z","twitterV2":"Fp-z","pinterestV2":"Gp-z"};